import React from 'react';

import ClassTitle from '../ClassTitle';
import OtherInstructorsSelect from '../OtherInstructorsSelect';
import PrimaryInstructorSelect from '../PrimaryInstructorSelect';
import SecondaryInstructorSelect from '../SecondaryInstructorSelect';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function ScheduleClassRow({ cls }) {
  return (
    <TableRow key={cls.id}>
      <TableCell>
        <ClassTitle cls={cls} />
      </TableCell>
      <TableCell>{cls.academy_topic.junction_number || '-'}</TableCell>
      <TableCell>
        <PrimaryInstructorSelect cls={cls} />
      </TableCell>
      <TableCell>
        <SecondaryInstructorSelect cls={cls} />
      </TableCell>
      <TableCell>
        <OtherInstructorsSelect cls={cls} />
      </TableCell>
    </TableRow>
  );
}

export default ScheduleClassRow;
